import React from 'react';
import styled from 'styled-components';
import { devices, theme } from 'styles/theme';
import Link from 'next/link';

const Social = ({iconColor, facebook, twitter, instra, linkedin, youtube, pinterest, bg, hoverbg, iconhover}) => {


  return (

    <StyledSocial iconhover={iconhover} className={'social-item-wrapper'}>
      <ul className={'social'}>
        {
            facebook &&
            <li><Link href={facebook || 'facebook'} prefetch={true}
                      target={'_blank'} rel="noreferrer">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1186_2285)">
                        <path d="M13.1515 10.0373L13.612 7.03571H10.734V5.08815C10.7143 4.86408 10.7452 4.63844 10.8243 4.42789C10.9034 4.21733 11.0288 4.02722 11.1912 3.87158C11.3536 3.71594 11.5489 3.59874 11.7626 3.52862C11.9763 3.4585 12.203 3.43725 12.426 3.46643H13.7355V0.912945C12.9674 0.788122 12.1912 0.719626 11.413 0.708008C9.04055 0.708008 7.49052 2.14255 7.49052 4.74796V7.03571H4.8537V10.0373H7.49052V17.2934H10.7353V10.0373H13.1515Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1186_2285">
                            <rect width="16.5854" height="16.5854" fill="white" transform="translate(0.707336 0.707764)" />
                        </clipPath>
                    </defs>
                </svg>


            </Link>
            </li>

        }

          {
              twitter &&
              <li><Link prefetch={true} href={twitter || '/'}
                        target={'_blank'} rel="noreferrer">

                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M15.6245 15.4795L10.4433 7.92777L10.4522 7.93484L15.1237 2.52222H13.5626L9.75704 6.9277L6.73494 2.52222H2.6407L7.4778 9.57278L7.47721 9.57218L2.37561 15.4795H3.93672L8.16764 10.5781L11.5302 15.4795H15.6245ZM6.11639 3.70015L13.3859 14.3016H12.1488L4.87341 3.70015H6.11639Z" fill="white" />
                  </svg>


              </Link>
              </li>

          }

          {
              instra &&
              <li><Link prefetch={true} href={instra || '/'}
                        target={'_blank'} rel="noreferrer">
                  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M11.6048 0.707764C12.8477 0.709343 14.0393 1.23497 14.9183 2.1687C15.7972 3.10252 16.2917 4.36858 16.2933 5.68921V12.3113C16.2919 13.6321 15.7973 14.8988 14.9183 15.8328C14.0394 16.7664 12.8477 17.2911 11.6048 17.2927H5.3714C4.12851 17.2912 2.93685 16.7665 2.05792 15.8328C1.17891 14.8988 0.68433 13.6321 0.682922 12.3113V5.68921C0.684463 4.36859 1.17904 3.10252 2.05792 2.1687C2.93686 1.23496 4.1285 0.709336 5.3714 0.707764H11.6048ZM5.37238 2.26929C4.51885 2.27024 3.70066 2.63112 3.09698 3.27222C2.4933 3.9135 2.15277 4.78319 2.15167 5.69019V12.3123C2.15253 13.2195 2.49226 14.0897 3.09601 14.7312C3.69973 15.3727 4.51859 15.7332 5.37238 15.7341H11.6048C12.4586 15.7332 13.2774 15.3726 13.8812 14.7312C14.4849 14.0897 14.8246 13.2195 14.8255 12.3123V5.69019C14.8244 4.78319 14.4848 3.9135 13.8812 3.27222C13.2774 2.63088 12.4585 2.2702 11.6048 2.26929H5.37238ZM8.55402 4.91577C9.57338 4.91686 10.551 5.34817 11.2718 6.11401C11.9923 6.87979 12.3977 7.9179 12.3987 9.00073C12.3986 9.8084 12.1727 10.5978 11.7503 11.2693C11.3279 11.9408 10.728 12.4651 10.0257 12.7742C9.32342 13.0832 8.55051 13.1631 7.80499 13.0056C7.05938 12.848 6.3738 12.4596 5.83624 11.8884C5.29878 11.3174 4.93288 10.5897 4.78448 9.79761C4.63614 9.00539 4.71237 8.18354 5.00323 7.43726C5.29409 6.69114 5.78636 6.05303 6.41827 5.60425C7.05033 5.15541 7.79379 4.91591 8.55402 4.91577ZM9.4964 6.58374C9.04649 6.38573 8.55117 6.33436 8.07355 6.4353C7.59598 6.53626 7.15712 6.78529 6.81281 7.15112C6.46853 7.51697 6.23397 7.98356 6.13898 8.49097C6.0441 8.99824 6.09335 9.52387 6.2796 10.0017C6.46596 10.4797 6.78094 10.8891 7.18585 11.1765C7.59075 11.4639 8.06706 11.6169 8.55402 11.6169C9.20671 11.6162 9.83267 11.3406 10.2943 10.8503C10.7559 10.3599 11.0152 9.69434 11.0159 9.00073C11.0159 8.48336 10.8714 7.97779 10.6009 7.54761C10.3303 7.11742 9.94628 6.78174 9.4964 6.58374ZM12.6214 3.66968C12.7415 3.6697 12.861 3.69503 12.972 3.7439C13.0828 3.79278 13.1831 3.86466 13.2679 3.95483C13.3528 4.04515 13.4202 4.15227 13.4661 4.27026C13.512 4.38822 13.5365 4.5147 13.5364 4.64233C13.5364 4.83453 13.4826 5.02254 13.3821 5.18237C13.2816 5.34228 13.1382 5.46717 12.971 5.54077C12.8037 5.61437 12.6193 5.63304 12.4417 5.59546C12.2642 5.55785 12.1009 5.46584 11.973 5.32983C11.8451 5.19385 11.7583 5.02033 11.723 4.83179C11.6877 4.64309 11.7054 4.44698 11.7747 4.26929C11.8441 4.09158 11.962 3.93955 12.1126 3.83276C12.2632 3.72605 12.4404 3.66954 12.6214 3.66968Z"
                          fill="white" />
                  </svg>


              </Link>
              </li>
          }

          {

              youtube &&
              <li><Link prefetch={true} href={youtube || '/'}
                        target={'_blank'} rel="noreferrer">
                  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1186_2300)">
                          <path d="M16.2927 7.11248C16.2927 6.63453 16.2041 6.16125 16.0319 5.71968C15.8598 5.2781 15.6075 4.87688 15.2894 4.53891C14.9713 4.20094 14.5937 3.93285 14.1781 3.74995C13.7625 3.56704 13.3171 3.4729 12.8672 3.4729H4.10847C3.19998 3.4729 2.32869 3.85636 1.68629 4.53891C1.04388 5.22146 0.682922 6.14721 0.682922 7.11248V11.4436C0.682922 12.4089 1.04388 13.3346 1.68629 14.0172C2.32869 14.6997 3.19998 15.0832 4.10847 15.0832H12.8672C13.3171 15.0832 13.7625 14.989 14.1781 14.8061C14.5937 14.6232 14.9713 14.3551 15.2894 14.0172C15.6075 13.6792 15.8598 13.278 16.0319 12.8364C16.2041 12.3948 16.2927 11.9216 16.2927 11.4436V7.11248ZM11.1423 9.60235L7.21434 11.6668C7.0608 11.755 6.53703 11.6372 6.53703 11.4506V7.21239C6.53703 7.02428 7.06448 6.90564 7.21802 6.9993L10.9778 9.17229C11.1335 9.26829 11.3017 9.51025 11.1423 9.60235Z" fill="white" />
                      </g>
                      <defs>
                          <clipPath id="clip0_1186_2300">
                              <rect width="15.6098" height="16.5854" fill="white" transform="translate(0.682922 0.708252)" />
                          </clipPath>
                      </defs>
                  </svg>


              </Link></li>

          }

          {
              linkedin &&
              <li>
                  <Link href={linkedin || '/'} prefetch={true} target={'_blank'} rel="noreferrer">

                      <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle opacity="0.5" cx="21" cy="21" r="20" stroke="#F4F4F4" />
                          <path fillRule="evenodd" clipRule="evenodd" d="M21.4242 18.33V19.7442C21.7203 19.2931 22.1285 18.9266 22.6088 18.6806C23.0891 18.4346 23.625 18.3175 24.1642 18.3408C27.0433 18.3408 27.6658 20.1408 27.6658 22.4825V27.25H24.9992V23.0233C24.9992 22.015 24.7958 20.7183 23.2258 20.7183C21.7033 20.7183 21.4433 21.8158 21.4433 22.9483V27.25H18.785V18.33H21.4242ZM16.9992 16.0883C16.9988 16.3525 16.9205 16.6107 16.7741 16.8305C16.6276 17.0504 16.4195 17.2221 16.1758 17.3242C15.9323 17.4254 15.6641 17.4519 15.4054 17.4002C15.1468 17.3486 14.9093 17.2212 14.7233 17.0342C14.537 16.847 14.4101 16.609 14.3587 16.35C14.3072 16.0909 14.3335 15.8225 14.4343 15.5784C14.535 15.3342 14.7056 15.1253 14.9248 14.9779C15.1439 14.8306 15.4017 14.7513 15.6658 14.75C15.8413 14.75 16.0151 14.7847 16.1772 14.852C16.3393 14.9193 16.4865 15.0179 16.6104 15.1423C16.7343 15.2666 16.8324 15.4142 16.8991 15.5766C16.9658 15.7389 16.9998 15.9128 16.9992 16.0883Z" fill="#F4F4F4" />
                          <path d="M16.9997 18.3408H14.333V27.25H16.9997V18.3408Z" fill="#F4F4F4" />
                      </svg>

                  </Link>
              </li>
          }

          {
              pinterest &&
              <li>
                  <Link prefetch={true} href={pinterest || '/'} target={'_blank'} rel="noreferrer">

                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                          <g id="Group_23863" data-name="Group 23863" transform="translate(17861 4413)">
                              <circle id="Ellipse_99" data-name="Ellipse 99" cx="15" cy="15" r="15" transform="translate(-17861 -4413)" fill={bg ? bg : theme.colors.hover} />
                              <circle id="Ellipse_98" className={'hover_circle'} data-name="Ellipse 99" cx="15" cy="15" r="0" transform="translate(-17861 -4413)" fill={hoverbg ? hoverbg : theme.colors.hover} />
                              <g id="Group_23857" data-name="Group 23857" transform="translate(-17884.176 -4406.076)">
                                  <path id="Path_9210" data-name="Path 9210" d="M44.92,4.239a3.873,3.873,0,0,1-2.34-.782A3.874,3.874,0,0,1,41.033.39h-2.51V7.248l0,3.756a2.275,2.275,0,1,1-1.56-2.156V6.3a4.939,4.939,0,0,0-.724-.054A4.812,4.812,0,0,0,32.62,7.864a4.716,4.716,0,0,0,.213,6.5,4.9,4.9,0,0,0,.453.4,4.813,4.813,0,0,0,2.95,1,4.939,4.939,0,0,0,.724-.053,4.8,4.8,0,0,0,2.68-1.34,4.7,4.7,0,0,0,1.41-3.344l-.013-5.609a6.359,6.359,0,0,0,3.891,1.322v-2.5H44.92Z" fill={iconColor ? iconColor : theme.colors.hover}/>
                    </g>
                  </g>
                </svg>

              </Link>
            </li>
        }


      </ul>
    </StyledSocial>

  );
};


const StyledSocial = styled.div`
    margin-bottom: 0;

    .social {
        display: flex;
        flex-direction: row;
        gap: 15px;

        li {
            list-style: none !important;
            cursor: pointer;

            &:after {
                display: none !important;
            }

            &:before {
                display: none !important;
            }

            a {
                &:after {
                    display: none !important;
                }

                &:before {
                    display: none !important;
                }
            }
        }

        svg {
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            .hover_circle, path, rect {
                transition: ${theme.transition};
            }
        }

        li {
            margin-left: 0;
            margin-bottom: 0 !important;
            &:first-child {
                margin-left: 0;
            }

            a {
                &:hover {
                    svg {
                        .hover_circle {
                            r: 15px;
                        }

                        rect {
                            fill: ${theme.colors.white};
                        }

                        path {
                            fill: ${theme.colors.secondaryGreen} !important;
                        }


                    }
                }
            }
        }
    }

    ${devices.ResponsiveTabMobile} {
        .social {
            li {
                margin-left: 0;
            }
        }
    }
`;

export default React.memo(Social);














